import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "placeholder"]
  connect() {
    if (this.imageTarget.complete) {
      if (this.imageTarget.naturalWidth > 0) this.loaded()
      else this.failed()
    }
  }
  loaded() { this.element.classList.add('moment-photo--loaded'); this.placeholderTarget.hidden = true }
  failed() { this.placeholderTarget.textContent = "Photo unavailable" }
}
